export default __webpack_public_path__ + "static/media/blog-post-layout-01-img-02.79b72be1.jpg";